"use client";

import Image from "next/image";
import Link from "next/link";
import { useParams } from "next/navigation";

import { links } from "@/data/links";
import { Lang } from "@/i18n-config";
import { getTranslations } from "@/utils/i18n/get-translations";

export default function NotFound() {
  const { lang, symbol }: { lang: Lang; symbol: string } = useParams();
  const { t } = getTranslations(lang);

  return (
    <div className="flex min-h-[calc(100dvh-var(--my-navbar-height))] flex-col items-center justify-center bg-[#F0F9FF] px-4 py-8 md:px-6 lg:px-8">
      <h1 className="mb-6 text-3xl font-semibold lg:text-[40px] lg:leading-tight">
        {t.analysis.noSymbol({ symbol })}
      </h1>
      <Link
        href={`/${lang}/${links.myAnalysisSearch}`}
        className="mb-12 text-base font-medium text-sky-600"
      >
        {t.analysis.checkOtherSymbol}
      </Link>
      <Image
        src="/analysis/no-symbol.png"
        width={1188}
        height={800}
        alt="No symbol"
        className="w-full max-w-xl"
      />
    </div>
  );
}
